import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function LinkIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 3.4V12H9V3.4L13 7.4L14.4 6L8.7 0.3C8.3 -0.1 7.7 -0.1 7.3 0.3L1.6 6L3 7.4L7 3.4Z" />
        <path d="M14 14H2V11H0V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V11H14V14Z" />
      </svg>
    </Icon>
  );
}
